module.exports = __webpack_public_path__ + "static/media/user-injured.2b749984.svg";